import {environment} from "environments";

class RxHubComponent {
  constructor(Orders, Auth, Users) {
    Object.assign(this, {
      Orders,
      Users,
      Auth,
      counts: {
        missing: 0,
        fails: 0,
      },
      orders: [],
      fails: [],
      missing: [],
      sent_items: [
        {
          row_title: "Number of legal documents sent",
          last_hour: 0,
          last_three_hours: 0,
          last_twelve_hours: 0
        },
        {
          row_title: "Number of order2dispense sent",
          last_hour: 0,
          last_three_hours: 0,
          last_twelve_hours: 0
        }
      ],
      pagination: {
        limit: 20,
        total: 9999,
        offset: 0,
        sort: 'dispense_order_id',
        order: 'desc',
        search: '',
      },
      BOD_2451: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      BODACDC_3272: FEATURE_BODACDC_3272,
      isLoading: false,
    });
  }

  get isSuperUser() {
    return _.includes(this.Auth.profile?.roles, this.Users.ROLES.SUPER.NAME);
  }

  $onInit() {
    this.getRxHubIntegrations();
  }

  onPageChange() {
    this.getRxHubIntegrations();
  }

  onSortChange() {
    this.getRxHubIntegrations();
  }
  getRxHubIntegrations() {
    this.isLoading = true;
    this.Orders.getRxhubIntegrations(this.pagination)
      .then(({ data }) => {
        const { counts, orders, fails, missing } = data;
        this.sent_items[0].last_hour = counts.last_one_hour_legal_doc_sent;
        this.sent_items[0].last_three_hours = counts.last_three_hour_legal_doc_sent;
        this.sent_items[0].last_twelve_hours = counts.last_twelve_hour_legal_doc_sent;
        this.sent_items[1].last_hour = counts.last_one_hour_o2d_sent;
        this.sent_items[1].last_three_hours = counts.last_three_hour_o2d_sent;
        this.sent_items[1].last_twelve_hours = counts.last_twelve_hour_o2d_sent;
        this.orders = orders;
        this.fails = fails;
        this.missing = missing;
        if (this.BOD_2451) {
          this.counts.fails = counts.fails;
          this.counts.missing = counts.missing;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

RxHubComponent.$inject = ['Orders', 'Auth', 'Users'];
angular.module('pims').component('rxHub', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/rx-hub.component.html',
  controller: RxHubComponent,
  controllerAs: 'vm',
  bindings: {}
});
